import React, { useState } from 'react';
import Navbar from './component/Navbar';
import Footer from './component/Footer';

const Privacy = () => {
  const [activeSection, setActiveSection] = useState('overview');

  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const sections = [
    { id: 'overview', title: '1. Overview & Consent', icon: 'fas fa-shield-alt' },
    { id: 'collection', title: '2. Information We Collect', icon: 'fas fa-database' },
    { id: 'cookies', title: '3. Cookies & Tracking', icon: 'fas fa-cookie-bite' },
    { id: 'usage', title: '4. How We Use Data', icon: 'fas fa-chart-line' },
    { id: 'security', title: '5. Security & Tokenization', icon: 'fas fa-lock' },
    { id: 'grievance', title: '6. Grievance Officer', icon: 'fas fa-user-shield' },
  ];

  return (
    <div style={{ backgroundColor: '#060816', color: '#FFFFFF', minHeight: '100vh', position: 'relative' }}>
      {/* Navbar Navigation Header */}
      <Navbar onOpenConsultation={() => (window.location.href = '/contact')} />

      {/* Main Content Area */}
      <main style={{ paddingTop: '78px', paddingBottom: '50px' }}>
        <div className="ht-container">
          {/* Hero Header Section */}
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '24px' }}>
            <span
              style={{
                background: 'rgba(0, 212, 255, 0.12)',
                color: '#00D4FF',
                padding: '5px 14px',
                borderRadius: '20px',
                fontSize: '0.75rem',
                fontWeight: 800,
                letterSpacing: '1.2px',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '12px',
              }}
            >
              <i className="fas fa-user-lock"></i>
              <span>PRIVACY & DATA GOVERNANCE</span>
            </span>

            <h1 className="text-gradient" style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)', fontWeight: 900, margin: '6px 0 10px 0', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Privacy Policy & Data Security
            </h1>

            <p style={{ color: '#A3A8B8', fontSize: '1rem', maxWidth: '720px', margin: '0 auto 14px auto', lineHeight: 1.5, fontFamily: "'Inter', sans-serif" }}>
              Hungry Top Technologies Limited is committed to maintaining strict data protection, user confidentiality, and global security compliance (GDPR, HIPAA, SOC2, PCI-DSS).
            </p>

            <span style={{ fontSize: '0.78rem', color: '#34D399', fontWeight: 700, background: 'rgba(52, 211, 153, 0.12)', padding: '3px 12px', borderRadius: '12px', border: '1px solid rgba(52, 211, 153, 0.3)' }}>
              Last Updated: June 2026 • Official Document
            </span>
          </div>

          {/* Quick Table of Contents Navigation Pills */}
          <div
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
              marginBottom: '24px',
              justifyContent: 'center',
            }}
          >
            {sections.map((sec) => (
              <button
                key={sec.id}
                onClick={() => scrollToSection(sec.id)}
                style={{
                  padding: '8px 18px',
                  borderRadius: '30px',
                  fontSize: '0.82rem',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  border: activeSection === sec.id ? '1px solid rgba(0, 212, 255, 0.8)' : '1px solid rgba(255, 255, 255, 0.08)',
                  background: activeSection === sec.id ? 'linear-gradient(135deg, rgba(0, 212, 255, 0.25) 0%, rgba(108, 99, 255, 0.25) 100%)' : 'rgba(15, 23, 42, 0.7)',
                  color: activeSection === sec.id ? '#00D4FF' : '#94A3B8',
                  transition: 'all 0.25s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <i className={sec.icon} style={{ fontSize: '0.78rem' }}></i>
                <span>{sec.title}</span>
              </button>
            ))}
          </div>

          {/* Document Content Card */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            {/* Section 1: Overview & Consent */}
            <section
              id="overview"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(0, 212, 255, 0.15)', border: '1px solid rgba(0, 212, 255, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00D4FF' }}>
                  <i className="fas fa-shield-alt" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  1. Overview & Your Consent
                </h2>
              </div>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.7, marginBottom: '16px', fontFamily: "'Inter', sans-serif" }}>
                This site is owned and operated by <strong>Hungry Top Technologies Limited</strong> (<strong>“HungryTop”, “Company”, “we”, “us”</strong> and <strong>“our”</strong>), a corporate entity incorporated under the laws of India having its registered office at <strong>BL-5, PH-II, Golf Green Urban Complex, Kolkata – 700095, West Bengal, India</strong>.
              </p>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.7, marginBottom: '16px', fontFamily: "'Inter', sans-serif" }}>
                This Privacy Policy (<strong>“Policy”</strong>) describes our protocols regarding the collection, storage, processing, transfer, and protection of your personal information when you access or use the <a href="https://www.hungrytop.com" style={{ color: '#00D4FF', textDecoration: 'none' }}>www.hungrytop.com</a> website or HungryTop mobile applications (collectively, the <strong>“HungryTop Platform”</strong>).
              </p>

              <div style={{ background: 'rgba(0, 212, 255, 0.08)', padding: '18px 22px', borderRadius: '16px', border: '1px solid rgba(0, 212, 255, 0.25)', marginTop: '20px' }}>
                <span style={{ color: '#00D4FF', fontWeight: 800, fontSize: '0.88rem', textTransform: 'uppercase', display: 'block', marginBottom: '6px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  ✓ Explicit User Consent
                </span>
                <p style={{ color: '#E2E8F0', fontSize: '0.92rem', margin: 0, lineHeight: 1.6 }}>
                  By accessing or using the HungryTop Platform and associated Services, you explicitly consent to the collection, storage, transfer, and processing of your personal data as outlined in this Policy and in accordance with applicable data protection laws.
                </p>
              </div>
            </section>

            {/* Section 2: Information We Collect */}
            <section
              id="collection"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(108, 99, 255, 0.15)', border: '1px solid rgba(108, 99, 255, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#A78BFA' }}>
                  <i className="fas fa-database" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  2. Information We Collect
                </h2>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '24px' }} className="privacy-collection-grid">
                <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '20px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                  <span style={{ color: '#00D4FF', fontWeight: 800, fontSize: '0.92rem', display: 'block', marginBottom: '8px' }}>
                    👤 Information Provided Directly
                  </span>
                  <ul style={{ paddingLeft: '18px', color: '#CBD5E1', fontSize: '0.88rem', lineHeight: 1.65 }}>
                    <li>Full Name, Email Address, and Phone Number.</li>
                    <li>Account credentials and authentication tokens.</li>
                    <li>Billing details and payment transaction records.</li>
                    <li>KYC documentation for enterprise partners & merchants.</li>
                  </ul>
                </div>

                <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '20px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.08)' }}>
                  <span style={{ color: '#A78BFA', fontWeight: 800, fontSize: '0.92rem', display: 'block', marginBottom: '8px' }}>
                    📱 Automated Technical Data
                  </span>
                  <ul style={{ paddingLeft: '18px', color: '#CBD5E1', fontSize: '0.88rem', lineHeight: 1.65 }}>
                    <li>Device model, IP address, OS type, and Browser fingerprint.</li>
                    <li>Real-time GPS / geolocation coordinates (with explicit permission).</li>
                    <li>Application usage telemetry, crash logs, and session analytics.</li>
                    <li>API interaction metrics and response performance logs.</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Section 3: Cookies & Tracking */}
            <section
              id="cookies"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(245, 158, 11, 0.15)', border: '1px solid rgba(245, 158, 11, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#F59E0B' }}>
                  <i className="fas fa-cookie-bite" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  3. Cookies & Tracking Technologies
                </h2>
              </div>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.7, marginBottom: '16px', fontFamily: "'Inter', sans-serif" }}>
                We use essential cookies, local web storage, and security pixels to authenticate users, prevent fraud, remember preferences, and analyze platform performance.
              </p>

              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '16px' }}>
                {['Essential Authentication Cookies', 'Session Security Tokens', 'Performance Telemetry', 'Preference Storage'].map((item, idx) => (
                  <span key={idx} style={{ background: 'rgba(245, 158, 11, 0.12)', border: '1px solid rgba(245, 158, 11, 0.3)', color: '#F59E0B', padding: '6px 14px', borderRadius: '10px', fontSize: '0.8rem', fontWeight: 700 }}>
                    ✓ {item}
                  </span>
                ))}
              </div>
            </section>

            {/* Section 4: How We Use Information */}
            <section
              id="usage"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.75)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(52, 211, 153, 0.15)', border: '1px solid rgba(52, 211, 153, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#34D399' }}>
                  <i className="fas fa-chart-line" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  4. How We Process & Use Your Information
                </h2>
              </div>

              <ul style={{ paddingLeft: '20px', color: '#CBD5E1', fontSize: '0.94rem', lineHeight: 1.75 }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Service Delivery:</strong> To provision, operate, personalise, and maintain our enterprise software platforms and mobile applications.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>FinTech & Commerce Processing:</strong> To execute secure credit underwriting, loan approvals (PaperLoan), order fulfillment, and payment card tokenization.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Platform Security & Fraud Prevention:</strong> To monitor system threat vectors, detect unauthorized access, and enforce SOC2 & ISO 27001 zero-trust security perimeters.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Regulatory Compliance:</strong> To satisfy mandatory statutory requirements under the Information Technology Act 2000, Reserve Bank of India (RBI) directives, GDPR, and HIPAA data laws.
                </li>
              </ul>
            </section>

            {/* Section 5: Data Security & PCI Compliance */}
            <section
              id="security"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.12) 0%, rgba(15, 23, 42, 0.9) 100%)',
                border: '1px solid rgba(16, 185, 129, 0.35)',
                boxShadow: '0 15px 40px rgba(0, 0, 0, 0.5)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(16, 185, 129, 0.25)', border: '1px solid rgba(16, 185, 129, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10B981' }}>
                  <i className="fas fa-lock" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  5. Data Security, Encryption & Cloud Infrastructure
                </h2>
              </div>

              <p style={{ color: '#E2E8F0', fontSize: '0.96rem', lineHeight: 1.7, marginBottom: '20px', fontFamily: "'Inter', sans-serif" }}>
                We deploy military-grade technical and physical safeguards to ensure complete confidentiality of user data across all stages of transit and storage.
              </p>

              {/* Security Standards Pills */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '24px' }} className="security-badges-grid">
                <div style={{ background: 'rgba(6, 8, 22, 0.8)', padding: '16px', borderRadius: '14px', border: '1px solid rgba(16, 185, 129, 0.3)', textAlign: 'center' }}>
                  <i className="fas fa-shield-alt" style={{ color: '#10B981', fontSize: '1.4rem', marginBottom: '8px', display: 'block' }}></i>
                  <span style={{ color: '#FFF', fontWeight: 800, fontSize: '0.88rem', display: 'block' }}>PCI-DSS Level 1</span>
                  <span style={{ color: '#94A3B8', fontSize: '0.72rem' }}>Encrypted Payment Tokenization Vault</span>
                </div>

                <div style={{ background: 'rgba(6, 8, 22, 0.8)', padding: '16px', borderRadius: '14px', border: '1px solid rgba(0, 212, 255, 0.3)', textAlign: 'center' }}>
                  <i className="fas fa-key" style={{ color: '#00D4FF', fontSize: '1.4rem', marginBottom: '8px', display: 'block' }}></i>
                  <span style={{ color: '#FFF', fontWeight: 800, fontSize: '0.88rem', display: 'block' }}>AES-256 E2EE</span>
                  <span style={{ color: '#94A3B8', fontSize: '0.72rem' }}>End-to-End Encrypted Data Pipelines</span>
                </div>

                <div style={{ background: 'rgba(6, 8, 22, 0.8)', padding: '16px', borderRadius: '14px', border: '1px solid rgba(167, 139, 250, 0.3)', textAlign: 'center' }}>
                  <i className="fab fa-aws" style={{ color: '#FF9900', fontSize: '1.4rem', marginBottom: '8px', display: 'block' }}></i>
                  <span style={{ color: '#FFF', fontWeight: 800, fontSize: '0.88rem', display: 'block' }}>AWS Cloud Guard</span>
                  <span style={{ color: '#94A3B8', fontSize: '0.72rem' }}>Multi-Region Isolated Enclaves</span>
                </div>
              </div>
            </section>

            {/* Section 6: Grievance Officer */}
            <section
              id="grievance"
              className="glass-card"
              style={{
                borderRadius: '24px',
                padding: '36px',
                background: 'rgba(15, 23, 42, 0.85)',
                border: '1px solid rgba(0, 212, 255, 0.4)',
                boxShadow: '0 20px 50px rgba(0, 0, 0, 0.6)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{ width: '38px', height: '38px', borderRadius: '12px', background: 'rgba(0, 212, 255, 0.2)', border: '1px solid rgba(0, 212, 255, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00D4FF' }}>
                  <i className="fas fa-user-shield" style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h2 style={{ fontSize: '1.4rem', color: '#FFF', fontWeight: 800, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  6. Grievance Officer & Contact Information
                </h2>
              </div>

              <p style={{ color: '#CBD5E1', fontSize: '0.96rem', lineHeight: 1.7, marginBottom: '24px', fontFamily: "'Inter', sans-serif" }}>
                In accordance with Rule 3 (1) of the Information Technology (Intermediaries Guidelines) Rules, 2011, any queries or grievances regarding data processing may be directed to our designated Grievance Officer:
              </p>

              <div
                style={{
                  background: 'rgba(6, 8, 22, 0.9)',
                  padding: '24px',
                  borderRadius: '18px',
                  border: '1px solid rgba(0, 212, 255, 0.3)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <span style={{ color: '#00D4FF', fontWeight: 800, fontSize: '1.1rem', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  HungryTop Grievance Officer
                </span>
                <p style={{ color: '#E2E8F0', fontSize: '0.92rem', margin: 0, lineHeight: 1.6 }}>
                  <strong>HungryTop Technologies Limited</strong><br />
                  BL-5, PH-II, Golf Green Urban Complex,<br />
                  Kolkata - 700095, West Bengal, India
                </p>

                <div style={{ display: 'flex', gap: '18px', marginTop: '10px', flexWrap: 'wrap' }}>
                  <a href="mailto:grievances@hungrytop.in" style={{ color: '#00D4FF', textDecoration: 'none', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="fas fa-envelope"></i>
                    <span>Email: grievances@hungrytop.in</span>
                  </a>
                  <a href="mailto:support@hungrytop.in" style={{ color: '#A78BFA', textDecoration: 'none', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <i className="fas fa-headset"></i>
                    <span>Support: support@hungrytop.in</span>
                  </a>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />

      {/* Responsive Styles Injection */}
      <style>{`
        @media (max-width: 768px) {
          .privacy-collection-grid,
          .security-badges-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Privacy;
